import * as Yup from 'yup'

export const registerDeviceValidationSchema = Yup.object().shape({
  name: Yup.string().required('Required'),
})
